if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');


        if(window.matchMedia('(max-width: 750px)').matches){

          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if(this.querySelector(".product-colors-and-options-wrapper")){
            this.querySelector(".product-colors-and-options-wrapper").classList.remove("hidden");

        var currentlySelectedSize = "";
       
             var sizeOptionWrapper = this.querySelector(".product-colors-and-options-wrapper")?.querySelector('.product-form__input[data-option-name="size"]') 
               || this.querySelector(".product-colors-and-options-wrapper")?.querySelector('.product-form__input[data-option-name="title"]')
               || this.querySelector(".product-colors-and-options-wrapper")?.querySelector('.product-form__input[data-option-name="value"]');
     
      if(sizeOptionWrapper){
       
        var currentlySelectedSize = sizeOptionWrapper?.querySelector('.radio-options-wrapper input:not(.size-chart-input):checked')?.value;
    
      }

            if(typeof currentlySelectedSize !== "undefined" && !currentlySelectedSize){
           // let sizeInput = sizeOptionWrapper?.querySelectorAll(`.radio-options-wrapper input:not([disabled-input])`)[0];
           // let sizeInputId = sizeInput.getAttribute("id");

           // document?.querySelector(`label[for="${sizeInputId}"]`).click();

         //this.querySelector(".product-colors-and-options-wrapper").classList.add("hidden");

           this.handleErrorMessage(window.variantStrings.selectSize);
        sizeOptionWrapper?.closest(".product-variant-picker-block")?.classList.add("has-error");
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

              
          return;
            }
          }
        } else {

          
      var currentlySelectedSize = "";
      var sizeOptionWrapper = document.querySelector('product-info')?.querySelector('.product-form__input[data-option-name="size"]')
        || document.querySelector('product-info')?.querySelector('.product-form__input[data-option-name="title"]')
          || document.querySelector('product-info')?.querySelector('.product-form__input[data-option-name="value"]');
      if(sizeOptionWrapper){
        sizeOptionWrapper?.closest(".product-variant-picker-block")?.classList.remove("has-error");
        var currentlySelectedSize = sizeOptionWrapper?.querySelector('.radio-options-wrapper input:not(.size-chart-input):checked')?.value;
    
      } else {

        if(this.querySelector('[data-size-input]')){
          currentlySelectedSize = this.querySelector('[data-size-input]:checked')?.value;
        }
        
      }

        if(this.querySelector(".wishlist-quick-add.only-one-variant")) {
          currentlySelectedSize = "one size";
        }
       
      if(!currentlySelectedSize){

           this.querySelector(".product-colors-and-options-wrapper")?.classList.add("hidden");

           this.handleErrorMessage(window.variantStrings.selectSize);
        sizeOptionWrapper?.closest(".product-variant-picker-block")?.classList.add("has-error");
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        return;
      }
        }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
          });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          if (e && e.name === 'AbortError') return; // add cancelled from the size prompt — not an error
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

      handleErrorMessage(errorMessage = false) {

        if (this.hideErrors) return;
        
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
  });
}
